import { getPartnerIntegrationOrigin } from '@vp/digital-url-service-lib-ubik'
import { getClientEnvironment } from '@vp/digital-environment-lib-ubik'
import { getIdentity } from '@vp/digital-auth-lib-ubik'
import { Logger } from '@vp/ubik-logging'

export const getPartnerAccountSiteIds = async (locale: string, logger: Logger, requestor: string) => {
  const { accessToken, canonicalId } = getIdentity()
  const url = `${getPartnerIntegrationOrigin(getClientEnvironment())}/api/v1/lite/project/card/siteIds/WIX/${canonicalId}/${locale}?requestor=${requestor}`
  const myHeaders = new Headers()
  myHeaders.append('authorization', `Bearer ${accessToken}`)

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
  }
  logger.log(`Fetching partner account site ids for ${canonicalId}, locale ${locale}`)
  try {
    const response = await fetch(url, requestOptions)
    // if customer does not have a Vista x Wix account the API returns 404 status
    if (response.status === 404) {
      logger.log(`Unable to fetch partner account site ids for ${canonicalId}, locale ${locale} returning []`, response)
      return []
    }
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`)
    }

    const partnerAccountSiteIds = await response.json()
    // Validate: must be an array of strings
    if (!Array.isArray(partnerAccountSiteIds) || !partnerAccountSiteIds.every((item) => typeof item === 'string')) {
      throw new Error(`Invalid response: expected an array of strings, but got ${typeof partnerAccountSiteIds} (${JSON.stringify(partnerAccountSiteIds)})`)
    }
    logger.log(`Successfully fetched partner account site ids for ${canonicalId}, locale ${locale}`, partnerAccountSiteIds)
    return partnerAccountSiteIds
  } catch (error) {
    logger.error('Failed to fetch partner account site ids', error)
    return []
  }
}
